angular
    .module('dnecom.component.cart')
    .service('CartUtils', ["Resource", "$q", "CurrencyRates", "CurrencyFormatter", function (Resource, $q, CurrencyRates, CurrencyFormatter) {
        var self = this;

        self.isPromoCodeFixed = function (promoCode) {
            return promoCode.type == 'fixed';
        };

        self.getPromoCodeValue = function(promoCode, shippingCost) {
            if (promoCode) {
                if(promoCode.discountType == 'percent') {
                    return '-' + self.getPromoCodeBonus(promoCode) + '%';
                } else if (promoCode.discountType == 'fixed') {
                    return '-' + CurrencyFormatter.format(self.getPromoCodeBonus(promoCode), CurrencyRates.fetchInitialCurrency());
                } else {
                    return 'FREE SHIPPING';
                }
            }
        };

        self.getPromoCodeBonus = function(promoCode) {
            if(promoCode.discountType == 'percent') {
                return parseFloat(promoCode.bonus).toFixed(0);
            } else {
                return parseFloat(promoCode.bonus).toFixed(2);
            }
        };

        self.getItemTotal = function (item) {
            return fin(item.quantity * item.variant.price);
        };

        self.getItemSubtotalRegular = function (item) {
            return fin(item.quantity * item.variant.regularPrice);
        };

        self.getItemTotalSavings = function (item) {
            return fin(item.quantity * item.variant.savings);
        };

        /**
         * @param {IShoppingCart} cart
         * @param {number|undefined} shipping
         * @returns {number|*}
         */
        self.getCartTotal = function (cart, shipping) {
            if (!cart) {
                return 0;
            }

            let sum = _.reduce(_.map(cart.items, function (item) {
                return self.getItemTotal(item);
            }), function (memo, num) {
                return memo + num;
            }, 0);

            if (cart.promoCode) {
                const promoCode = cart.promoCode;
                const conditionType = promoCode.promoCode.conditionType;

                if ('orders_over' === conditionType && sum
                    && sum >= promoCode.promoCode.minOrderValue
                    || 'all_orders' === conditionType
                ) {
                    sum = applyPromoCodeByDiscountType(promoCode, sum, shipping);
                }

                if ('specific_product' === conditionType) {
                    const promoCodeProductId = promoCode.promoCode.product.id;
                    for (const item of cart.items) {
                        if (item.product && item.product.id === promoCodeProductId) {
                            const itemSumWithoutShipping = self.getItemTotal(item);
                            const itemSumWithDiscount = applyPromoCodeByDiscountType(promoCode, itemSumWithoutShipping, shipping);
                            sum -= itemSumWithoutShipping;
                            sum += itemSumWithDiscount;
                            break;
                        }
                    }
                }
            }

            if (shipping !== undefined) {
                sum += shipping;
            }

            return Math.ceil(sum.toFixed(4) * 100) / 100;
        };

        /**
         * @param {ICartPromoCode} promoCode
         * @param {number} total
         * @param {number|undefined} shipping
         * @return {number}
         */
        function applyPromoCodeByDiscountType(promoCode, total, shipping) {
            const bonus = promoCode.promoCode.bonus;
            const discountType = promoCode.promoCode.discountType;

            if ('percent' === discountType) {
                total -= (bonus / 100) * total;
            } else if ('fixed' === discountType) {
                total -= bonus;
            } else if ('free_shipping' === discountType && shipping !== undefined) {
                total -= shipping;
            }

            if (total < 0 && discountType !== 'free_shipping') {
                total = 0;
            }

            return total;
        }

        self.getCartSubtotalRegular = function (cart) {
            return fin(_.reduce(_.map(cart.items, function (item) {
                return self.getItemSubtotalRegular(item);
            }), function (memo, num) {
                return memo + num;
            }, 0));
        };

        self.getCartTotalSavings = function (cart) {
            return fin(_.reduce(_.map(cart.items, function (item) {
                return self.getItemTotalSavings(item);
            }), function (memo, num) {
                return memo + num;
            }, 0));
        };

        self.getCartTotalQuantity = function (cart) {
            return fin(_.reduce(_.map(cart.items, function (item) {
                return item.quantity;
            }), function (memo, num) {
                return memo + num;
            }, 0));
        };

        self.getCartUrl = function(cart) {
            return document.location.origin + Routing.generate('stores_fe_cart', { hash: cart.hash });
        };

        self.isPromoCodeValid = function (promoCode, cart) {
            return !(promoCode.minOrderValue && parseFloat(promoCode.minOrderValue) > parseFloat(self.getCartTotal(cart)));
        };

        self.checkPromoCodeCustomerEmail = function (cart) {
            if (cart.customer != null && cart.customer.email != null) {
                return cart.customer.email;
            }

            return null;
        };

        self.fetchPromoCode = function (promoCodeName) {
            if (!promoCodeName || promoCodeName.length <= 0) {
                return;
            }

            return Resource.send('stores_fe_checkout_fetch_promo_code', null, {
                name: promoCodeName
            });
        };

        self.checkPromoCode = function (promoCodeName, cart) {
            if (!promoCodeName || promoCodeName.length <= 0) {
                return;
            }

            return Resource.send('stores_fe_checkout_check_promo_code', null, {
                name: promoCodeName,
                customerEmail: self.checkPromoCodeCustomerEmail(cart)
            });
        };

        self.getPromoCode = function (promoCodeName, cart) {
            return self.checkPromoCode(promoCodeName, cart)
                .then(function () {
                    return self.fetchPromoCode(promoCodeName);
                })
                .then(function (data) {
                    if (self.isPromoCodeValid(data.promoCode, cart)) {
                        return data;
                    } else {
                        return $q.reject({ message: "Sorry, this promo code applies to orders above $" + data.promoCode.minOrderValue });
                    }
                })
                .catch(function (data) {
                    return $q.reject(data);
                });
        };

        return self;
    }]);
